import React from 'react';

/**
 * Components
 */
import Select from 'Components/Select';

export default ({inputErrors, handleSelect, handleYearSelect, handleContactSelect, yearsList, contactsList, reportYear, contact}) => {
  return (
    <section className='report-filters-section'>
      <header>Report Filters</header>
      <Select
        selectionList={yearsList}
        defaultItem={reportYear}
        mainWrapperClassName='_width_330 _height_90'
        inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
        dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
        label='Model Year *'
        error={inputErrors.reportYear}
        withoutSearch
        handleSelect={handleYearSelect} />

      <Select
        selectionList={contactsList}
        defaultItem={contact}
        itemNameIndicator='email'
        mainWrapperClassName='_width_330 _height_90'
        inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
        dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
        label='Recipient *'
        error={inputErrors.contact}
        withoutSearch
        handleSelect={handleSelect('contact')} />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ReportScene/MMLReport/index.jsx